import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';

export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const { navigateToSection } = useNavigation();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    navigateToSection(id);
    setIsOpen(false);
  };

  return (
    <div className="md:hidden">
      <button
        onClick={toggleMenu}
        className="p-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
        aria-label="Toggle menu"
      >
        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 shadow-lg animate-slide-down">
          <nav className="flex flex-col p-4">
            <a 
              href="#features" 
              onClick={(e) => handleNavigation(e, 'features')}
              className="py-3 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
            >
              Features
            </a>
            <a 
              href="#privacy" 
              onClick={(e) => handleNavigation(e, 'privacy')}
              className="py-3 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
            >
              Privacy
            </a>
            <Link 
              to="/qa" 
              onClick={() => setIsOpen(false)}
              className="py-3 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
            >
              Q&A
            </Link>
            <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800">
              <a 
                href="#waitlist" 
                onClick={(e) => handleNavigation(e, 'waitlist')}
                className="block w-full bg-primary-500 text-white text-center px-4 py-3 rounded-lg 
                  hover:bg-primary-600 transition-colors font-medium"
              >
                Join Waitlist
              </a>
            </div>
          </nav>
        </div>
      )}
    </div>
  );
}